module.exports = __webpack_public_path__ + "static/media/wrecker_purple.5cd6dbd2.svg";